// extracted by mini-css-extract-plugin
export var answer = "faq-module--answer--UFJGQ";
export var header = "faq-module--header--L1MxA";
export var question = "faq-module--question--3Gh9V";
export var questionsWrapper = "faq-module--questionsWrapper--RBaCQ";
export var singleQuestion = "faq-module--singleQuestion--BGWTR";
export var wrapper = "faq-module--wrapper--p1Z8W";